"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { getCaseStudies } from "@/lib/content-engine";
import { UniversalLogo } from "@/components/ui/UniversalLogo";

export default function CaseStudiesIndex() {
  const caseStudies = getCaseStudies();

  return (
    <div className="min-h-screen bg-slate-50 pt-24">
      {/* HEADER */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 pt-10 pb-16 md:pt-16 md:pb-16 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Case Studies
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Real-world results. See how we help companies modernize, scale, and automate.
          </p>
        </div>
      </div>

      {/* GRID */}
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseStudies.map((study) => (
            <Link 
              key={study.slug} 
              href={`/case-studies/${study.slug}`}
              className="group bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-xl hover:border-red-100 transition-all duration-300 flex flex-col h-full"
            >
              {/* TOP SECTION: LOGO CONTAINER */}
              {/* REMOVED: grayscale classes. Now full color. */}
              <div className="h-56 bg-slate-50 border-b border-slate-100 relative flex items-center justify-center p-10 group-hover:bg-slate-100 transition-colors">
                <div className="absolute top-4 left-4">
                  <span className="bg-white/80 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider text-slate-900 border border-slate-200 shadow-sm">
                    {study.category}
                  </span>
                </div>
                {/* Large Logo - Full Color */}
                <UniversalLogo 
                  src={study.logo} 
                  alt={study.clientName || study.title} 
                  fallbackText={study.clientName}
                  className="max-h-24 w-auto object-contain transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* BOTTOM SECTION: TEXT */}
              <div className="p-8 flex flex-col grow">
                 <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-red-600 transition-colors line-clamp-2">
                   {study.title}
                 </h3>
                 <p className="text-slate-600 text-sm mb-6 grow line-clamp-3 leading-relaxed">
                   {study.excerpt}
                 </p>

                 {study.techStack && study.techStack.length > 0 && (
                   <div className="flex flex-wrap gap-2 mb-6">
                      {study.techStack.slice(0,3).map(tech => (
                        <span key={tech} className="text-xs font-mono bg-slate-100 text-slate-600 px-2 py-1 rounded">
                          {tech}
                        </span>
                      ))}
                   </div>
                 )}

                 <div className="flex items-center text-red-600 font-bold text-sm mt-auto">
                   Read Story <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                 </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}